export default __webpack_public_path__ + "static/media/portfolio-110.83646317.jpg";